import styled from 'styled-components';

// ── Layout ───────────────────────────────────────────────────

export const Container = styled.div`
  display: flex;
  height: 100vh;
  background: #f8f9fa;
  overflow: hidden;
`;

export const Sidebar = styled.div`
  width: 360px;
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: ${props => props.$showChat ? 'none' : 'flex'};
  }
`;

// ── Sidebar Header ───────────────────────────────────────────

export const SidebarHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e1e5e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #7B2FF7 0%, #E040A0 100%);
  color: white;
`;

export const SidebarTitle = styled.h3`
  margin: 0;
  color: white;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NewChatButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const SoundToggleButton = styled.button`
  background: ${props => props.$active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  opacity: ${props => props.$active ? 1 : 0.6};

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    opacity: 1;
  }
`;

export const HeaderActionButton = styled.button`
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.08);
  }
`;

// ── Conversations List ───────────────────────────────────────

export const ConversationsList = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const ConversationItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f5;
  cursor: pointer;
  transition: background 0.2s ease;
  background: ${props => props.$active ? 'rgba(123, 47, 247, 0.1)' : 'white'};
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    background: ${props => props.$active ? 'rgba(123, 47, 247, 0.15)' : '#f8f9fa'};
  }
`;

export const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${props => props.$avatarUrl
    ? `url(${props.$avatarUrl}) center/cover no-repeat`
    : `linear-gradient(135deg, ${props.$color || '#7B2FF7'}, ${props.$colorDark || '#6A1FE0'})`
  };
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.$avatarUrl ? 'transparent' : 'white'};
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
`;

export const ConversationInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConversationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
`;

export const ConversationName = styled.div`
  font-weight: 600;
  color: #333;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ConversationTime = styled.div`
  font-size: 11px;
  color: ${props => props.$unread ? '#7B2FF7' : '#6c757d'};
  font-weight: ${props => props.$unread ? '600' : '400'};
  white-space: nowrap;
`;

export const ConversationPreview = styled.div`
  font-size: 13px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UnreadBadge = styled.div`
  background: linear-gradient(135deg, #7B2FF7, #E040A0);
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
`;

// ── Messages Area ────────────────────────────────────────────

export const MessagesArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f0f2f5;

  @media (max-width: 768px) {
    display: ${props => props.$show ? 'flex' : 'none'};
    flex: 1;
    min-height: 0;
  }
`;

export const MessagesHeader = styled.div`
  padding: 12px 16px;
  background: linear-gradient(135deg, #7B2FF7 0%, #E040A0 100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const HeaderName = styled.div`
  font-weight: 600;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HeaderContact = styled.div`
  font-size: 12px;
  opacity: 0.9;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

// ── Messages ─────────────────────────────────────────────────

export const MessagesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
`;

export const DateSeparator = styled.div`
  align-self: center;
  margin: 8px auto;
  padding: 4px 14px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.35);
  color: white;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.2px;
  user-select: none;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

/* Floating date indicator (Telegram style) — shows current date while scrolling */
export const FloatingDate = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 14px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
  pointer-events: none;
  opacity: ${p => p.$visible ? 1 : 0};
  transition: opacity 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

export const MessageBubble = styled.div`
  max-width: 65%;
  padding: 8px 12px;
  border-radius: 8px;
  align-self: ${props => props.$outbound ? 'flex-end' : 'flex-start'};
  background: ${props => props.$outbound ? '#F0E6FF' : 'white'};
  color: #333;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    ${props => props.$outbound ? 'right: -8px' : 'left: -8px'};
    border-width: 8px;
    border-style: solid;
    border-color: ${props => props.$outbound
      ? '#F0E6FF transparent transparent transparent'
      : 'white transparent transparent transparent'
    };
  }

  @media (max-width: 768px) {
    max-width: 85%;
  }
`;

export const SenderName = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
  color: ${p => p.$color || '#7B2FF7'};
`;

export const MessageText = styled.div`
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
  white-space: pre-wrap;
`;

export const MessageMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
`;

export const MessageTime = styled.span`
  font-size: 11px;
  color: #667781;
`;

export const MessageStatus = styled.span`
  display: flex;
  align-items: center;
  color: ${props => {
    switch (props.$status) {
      case 'read': return '#53bdeb';
      case 'failed': return '#dc3545';
      default: return '#667781';
    }
  }};
`;

export const SystemMessage = styled.div`
  text-align: center;
  padding: 4px 12px;
  margin: 8px 0;
  font-size: 12px;
  color: #888;
  font-style: italic;
`;

export const MessageImage = styled.img`
  max-width: 280px;
  max-height: 300px;
  border-radius: 8px;
  margin-bottom: 4px;
  cursor: pointer;
`;

export const FileAttachment = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(0,0,0,0.05);
  border-radius: 8px;
  margin-bottom: 4px;
  text-decoration: none;
  color: #333;
  font-size: 13px;
  &:hover { background: rgba(0,0,0,0.08); }
`;

// ── Input Area ───────────────────────────────────────────────

export const MessageInputArea = styled.div`
  padding: 16px 20px 20px 20px;
  background: #f7f7fa;
  display: flex;
  gap: 10px;
  align-items: center;
  border-top: 1px solid #e8e6ec;
  min-height: 72px;
  box-sizing: border-box;
`;

export const AttachButton = styled.label`
  background: rgba(123, 47, 247, 0.08);
  border: none;
  color: #7B2FF7;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(123, 47, 247, 0.15);
    transform: scale(1.05);
  }

  input { display: none; }
`;

export const MessageTextarea = styled.textarea`
  flex: 1;
  padding: 12px 18px;
  border: 1px solid #e8e6ec;
  border-radius: 22px;
  font-size: 15px;
  resize: none;
  min-height: 44px;
  max-height: 140px;
  line-height: 1.4;
  background: white;
  font-family: inherit;
  color: #1c1917;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    border-color: #7B2FF7;
    box-shadow: 0 0 0 3px rgba(123, 47, 247, 0.1);
  }

  &::placeholder {
    color: #a8a29e;
  }
`;

export const SendButton = styled.button`
  background: linear-gradient(135deg, #7B2FF7 0%, #E040A0 100%);
  color: white;
  border: none;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(123, 47, 247, 0.3);

  &:hover:not(:disabled) {
    background: #6A1FE0;
    transform: scale(1.05);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// ── Empty States ─────────────────────────────────────────────

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  padding: 40px;
  text-align: center;
  background: #f0f2f5;
`;

export const EmptyIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(123, 47, 247, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  svg {
    width: 60px;
    height: 60px;
    color: #7B2FF7;
  }
`;

// ── Typing Indicator ────────────────────────────────────────

export const TypingIndicator = styled.div`
  padding: 4px 16px;
  font-size: 13px;
  color: #7B2FF7;
  font-style: italic;
  background: #f0f2f5;
`;

// ── Member Count ────────────────────────────────────────────

export const MemberCount = styled.div`
  font-size: 12px;
  color: rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MuteButton = styled.button`
  background: rgba(255,255,255,0.15);
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  &:hover { background: rgba(255,255,255,0.3); }
`;

// ── Mic / Voice Recording ───────────────────────────────────

export const MicButton = styled.button`
  background: #7B2FF7;
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #6A1FE0;
    transform: scale(1.05);
  }
`;

export const CircleButton = styled.button`
  background: #00a884;
  color: white;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #008f6f;
    transform: scale(1.05);
  }
`;

export const RecordingArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
`;

export const RecordingDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #dc3545;
  animation: pulse 1s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
`;

export const RecordingTimer = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  font-variant-numeric: tabular-nums;
`;

export const CancelRecordButton = styled.button`
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 4px;

  &:hover {
    opacity: 0.7;
  }
`;

// ── Context Menu ────────────────────────────────────────────

export const ContextMenu = styled.div`
  position: fixed;
  z-index: 1000;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15), 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 6px 0;
  min-width: 200px;
  animation: contextMenuIn 0.15s ease-out;

  @keyframes contextMenuIn {
    from { opacity: 0; transform: scale(0.92); }
    to { opacity: 1; transform: scale(1); }
  }
`;

export const ContextMenuItem = styled.button`
  width: 100%;
  padding: 10px 20px;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: ${props => props.$danger ? '#dc3545' : '#333'};
  transition: background 0.12s ease;
  white-space: nowrap;

  svg {
    color: ${props => props.$danger ? '#dc3545' : '#667781'};
    flex-shrink: 0;
  }

  &:hover { background: #f0f2f5; }
  &:active { background: #e4e6e9; }
`;

// ── Modal ───────────────────────────────────────────────────

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

export const Modal = styled.div`
  background: white;
  border-radius: 12px;
  width: 440px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
`;

export const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #e1e5e9;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
`;

export const ModalBody = styled.div`
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
`;

export const ModalFooter = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e1e5e9;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  margin-bottom: 12px;
  &:focus { border-color: #7B2FF7; }
`;

export const ModalButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  ${props => props.$primary ? `
    background: #7B2FF7;
    color: white;
    &:hover { background: #6A1FE0; }
  ` : `
    background: #f0f2f5;
    color: #333;
    &:hover { background: #e4e6e9; }
  `}

  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const UserCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  &:hover { background: #f5f5f5; }
  input { width: 18px; height: 18px; accent-color: #7B2FF7; }
`;

export const UserList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
`;

// ── Login Page ──────────────────────────────────────────────

export const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #7B2FF7 0%, #E040A0 100%);
`;

export const LoginCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px;
  width: 380px;
  max-width: 90vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.15);
`;

export const LoginTitle = styled.h1`
  text-align: center;
  color: #7B2FF7;
  font-size: 36px;
  margin: 0 0 4px;
`;

export const LoginSubtitle = styled.p`
  text-align: center;
  color: #6c757d;
  margin: 0 0 32px;
`;

export const LoginInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e1e5e9;
  border-radius: 10px;
  font-size: 15px;
  outline: none;
  margin-bottom: 12px;
  box-sizing: border-box;
  &:focus { border-color: #7B2FF7; }
`;

export const LoginButton = styled.button`
  width: 100%;
  padding: 12px;
  background: #7B2FF7;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 4px;
  transition: background 0.2s ease;
  &:hover { background: #6A1FE0; }
  &:disabled { opacity: 0.6; cursor: default; }
`;

export const LoginLink = styled.button`
  background: none;
  border: none;
  color: #7B2FF7;
  cursor: pointer;
  font-size: 14px;
  margin-top: 16px;
  display: block;
  width: 100%;
  text-align: center;
`;

export const ErrorText = styled.div`
  color: #dc3545;
  font-size: 13px;
  text-align: center;
  margin-bottom: 8px;
`;
